export default __webpack_public_path__ + "static/O0098-6d8ffc77dd4e763b25fa237411dfbefa.png";